<div class="dialog-header">
  <div class="dialogTitle">
    <span>Placemark Event Information</span>
  </div>
  <mat-icon class="dialogCloseIcon" svgIcon="dialog.close" (click)="close()"></mat-icon>
</div>
<div class="dialog-content">
  @if (eventInfo) {
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Asset Information">
        <div class="mat-tab-content">
          <span class="text-field">Asset Type</span>: <span class="text-value">
          {{eventInfo.assetType}}@if (!eventInfo.assetType) {
          <span class="not-applicable">NA</span>
        }
      </span><br>
      <span class="text-field">Aspect</span>: <span class="text-value">
      {{eventInfo.assetAspect}}@if (!eventInfo.assetAspect) {
      <span class="not-applicable">NA</span>
    }
  </span><br>
  <span class="text-field">Name</span>: <span class="text-value">
  {{eventInfo.assetName}}@if (!eventInfo.assetName) {
  <span class="not-applicable">NA</span>
}
</span><br>
<span class="text-field">Description</span>: <span class="text-value">
{{eventInfo.assetDesc}}@if (!eventInfo.assetDesc) {
<span class="not-applicable">NA</span>
}
</span><br>
<hr>
  @if (eventInfo.assetLoc) {
    <ins-expansion-box [titleHeight]="'auto'"
      [elementOnPanel]="false" [leftPositionedArrow]="false" [titleStyle]="{width: '100%', 'align-items': 'flex-end'}">
      <div titleContent class="expansion-title">Location</div>
      <div content class="expansionEntries">
        <div>
          <span class="text-field">Country</span>: <span class="text-value">{{eventInfo.assetLoc.country}}</span>
        </div>
        <div>
          <span class="text-field">Region</span>: <span class="text-value">{{eventInfo.assetLoc.region}}</span>
        </div>
        <div>
          <span class="text-field">Locality</span>: <span class="text-value">{{eventInfo.assetLoc.locality}}</span>
        </div>
        <div>
          <span class="text-field">Street Address</span>: <span class="text-value">{{eventInfo.assetLoc.streetAddress}}</span>
        </div>
        <div>
          <span class="text-field">Postal Code</span>: <span class="text-value">{{eventInfo.assetLoc.postalCode}}</span>
        </div>
        <div>
          <span class="text-field">Longitude</span>: <span class="text-value">{{eventInfo.assetLoc.longitude}}</span>
        </div>
        <div>
          <span class="text-field">Latitude</span>: <span class="text-value">{{eventInfo.assetLoc.latitude}}</span>
        </div>
      </div>
    </ins-expansion-box>
  }
  @if (!eventInfo.assetLoc) {
    <span class="text-field">Location:</span>
    } @if (!eventInfo.assetLoc) {
    <span class="text-value not-applicable">NA<br></span>
  }
</div>
</mat-tab>
<mat-tab label="Event Information">
  <div class="mat-tab-content">
    <span class="text-field">Event Name</span>: <span class="text-value">
    {{ eventInfo.ruleName }}@if (!eventInfo.ruleName) {
    <span class="not-applicable">NA</span>
  }
</span><br>
<span class="text-field">Source of Event</span>: <span class="text-value">
{{ eventInfo.source }}@if (!eventInfo.source) {
<span class="not-applicable">NA</span>
}
</span><br>
@if (eventInfo.ruleProps) {
  <span class="text-field">Rule Variable name and value</span>: @for (rule of eventInfo.ruleProps; track rule; let i = $index) {
  <span class="text-value"> {{rule.ruleVariable}}, {{rule.ruleVariableValue}}</span>
  }@if (!eventInfo.ruleProps) {
  <span class="not-applicable text-value">NA</span>
  }<br>
}
@if (ruleCondition) {
  <span class="text-field">Rule condition</span>: <span class="text-value">
  @for (rule of ruleCondition; track rule) {
    <span><a href="{{eventInfo.ruleUrl}}" target="_blank" class="url-link"> "property":"{{rule.property}}","condition":"{{rule.condition}}","threshold":"{{rule.threshold}}" </a><br>@if (!eventInfo.ruleUrl) {
    <span class="not-applicable">NA</span>
  }</span>
}
</span>
}
<span class="text-field">Action Severity</span>: <span class="text-value">
{{eventInfo.actionSeverity}}@if (!eventInfo.actionSeverity) {
<span class="not-applicable">NA</span>
}
</span><br>
<span class="text-field">Time stamp</span>: <span class="text-value">
{{ eventInfo.timestamp }}@if (!eventInfo.timestamp) {
<span class="not-applicable">NA</span>
}
</span><br>
<span class="text-field">Action Description</span>: <span class="text-value">
{{eventInfo.actionDesc}}@if (!eventInfo.actionDesc) {
<span class="not-applicable">NA</span>
}
</span><br>
<span class="text-field">Acknowledged</span>: <span class="text-value">
{{eventInfo.acknowledged}}@if (eventInfo.acknowledged == undefined) {
<span class="not-applicable">NA</span>
}
</span><br>
</div>
</mat-tab>
</mat-tab-group>
}
<div class="dialog-footer">
  <button class="actionButton blue" (click)="close()">Close</button>
</div>
</div>
